//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const AllergyIntolerance = createAsyncThunk(
  "AllergyIntolerance",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingAllergyIntolerance(""));
      const response = await UsePortalApi(
        `Patient/AllergyIntolerance`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
        response[0].hasOwnProperty('entry') ? dispatch(gettingAllergyIntoleranceSuccess(response[0].entry)) : dispatch(gettingAllergyIntoleranceFailed())

      } else {
        dispatch(
          gettingAllergyIntoleranceFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingAllergyIntoleranceFailed(error));
    }
  }
);
const AllergyIntoleranceSlice = createSlice({
  name: "AllergyIntolerance",
  initialState: {
    Allergies: null,
    isGetting: false,
    error: false,
  },
  reducers: {
    gettingAllergyIntolerance: (state, action) => {
      state.Allergies = null;
      state.isGetting = true;
      state.error = false;
    },
    gettingAllergyIntoleranceSuccess: (state, action) => {
      state.Allergies = action.payload;
      state.isGetting = false;
      state.error = false;
    },
    gettingAllergyIntoleranceFailed: (state, action) => {
      state.Allergies = null;
      state.isGetting = false;
      state.error = true;
    },
    gettingAllergyIntoleranceClear: (state, action) => {
      state.Allergies = null;
      state.isGetting = false;
      state.error = false;
    },
  },
});
export const {
  gettingAllergyIntolerance,
  gettingAllergyIntoleranceSuccess,
  gettingAllergyIntoleranceFailed,
  gettingAllergyIntoleranceClear,
} = AllergyIntoleranceSlice.actions;
export default AllergyIntoleranceSlice.reducer;
